class Media3D extends HTMLElement {
  constructor() {
    super()

    this.frame=0
    this.totalFrames = 0
    this.mouseDown = false
  }

  connectedCallback() {
    this.addEventListener('pointermove', this.onMouseMove.bind(this))
    this.addEventListener('mousedown', this.onMouseDown.bind(this))
    this.addEventListener('mouseup', this.onMouseUp.bind(this))
    this.addEventListener('touchmove', this.onTouchMove.bind(this))
  }

  disconnectedCallback() {

  }

  onMouseDown() {
    this.mouseDown = true
  }

  onMouseUp() {
    this.mouseDown = false
  }

  setTotalFrames() {
    this.playerObj = this.player.getLottie(this.frame)
    this.totalFrames = this.playerObj?.totalFrames || 0
  }

  onTouchMove(event) {
    const touch = event?.touches[0] || event?.changedTouches[0]
    this.mouseDown = true
    this.onMouseMove(event, touch.pageX)
  }

  onMouseMove(event, posX = '') {
    if (!this.mouseDown) return

    this.setTotalFrames()
    const viewportX = posX || event.pageX
    if (Math.abs(this.viewportX - viewportX) < 10) return

    if (viewportX < this.viewportX) this.frame --
    if (viewportX >= this.viewportX) this.frame ++
    this.viewportX = viewportX

    if (this.frame < 0) {
      this.frame = this.totalFrames - 1 + this.frame
    } else if (this.frame >= this.totalFrames) {
      this.frame = this.frame - this.totalFrames
    }

    this.player.seek(this.frame)
  }

  get player() {
    return this.querySelector('lottie-player')
  }
}

customElements.define('media-3d', Media3D)
